export function getRestrictedAccessTitle(
  isRestrictedAccess: boolean,
  isCancelled: boolean,
) {
  if (!isRestrictedAccess) return null
  if (isCancelled) {
    return 'Subscription cancelled'
  }
  return 'Review your invoices'
}

export function getRestrictedAccessDescription(
  isRestrictedAccess: boolean,
  isCancelled: boolean,
) {
  if (!isRestrictedAccess) return null
  if (isCancelled) {
    return 'In order to top up your account, please reactivate your subscription.'
  }
  return 'In order to top up your account, please review your payment method and any unpaid invoices.'
}
